export interface ServiceCredentialModifierInterface {
  id?: string;
  modifier: string;
  credentialId: string;
  serviceId?: string;
}

export class ServiceCredentialModifier
  implements ServiceCredentialModifierInterface
{
  id: string;
  modifier: string;
  credentialId: string;
  serviceId?: string;

  constructor(data: Partial<ServiceCredentialModifierInterface>) {
    this.id = data.id || '';
    this.modifier = data.modifier || '';
    this.credentialId = data.credentialId || '';
    this.serviceId = data.serviceId;
  }

  toJson(): ServiceCredentialModifierInterface {
    const idIsNumeric = /^\d+$/.test(this.id);
    return {
      id: idIsNumeric ? this.id : undefined,
      modifier: this.modifier,
      credentialId: this.credentialId,
      serviceId: this.serviceId,
    };
  }
}
